import React, { useState } from 'react';
import GenericModal from '../../../components/modal/GenericModal';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import { cancelarConvocatoriaAPI } from '../../../consumers/backendApisUrls';

// ──────────────────────────────────────────────────────────────────────────
// Confirmación de "Cancelar" una convocatoria Individual con asignación
// confirmada. POST TrasladosPromociones/CancelarConvocatoria (el id viaja en el
// body): libera la vacante reservada (RequerimientoPersonal.IdPostulanteTP) y deja
// la convocatoria en estado Cancelado. Las reglas las valida el lambda; el ícono
// solo se ofrece cuando la grilla trae row.puedeCancelar.
// ──────────────────────────────────────────────────────────────────────────
const CancelarConvocatoriaModal = ({ toggleModal, refreshPage, row }) => {
    const [managePostRequest] = useManagePostRequest();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        managePostRequest(
            cancelarConvocatoriaAPI(),
            { IdConvocatoria: row.idConvocatoria },
            () => {
                setIsSubmitting(false);
                toggleModal();
                refreshPage && refreshPage();
            },
            true,
            () => setIsSubmitting(false),
            true
        );
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Cancelar convocatoria" width="600px">
            <div className="modal-body pt-0">
                <div className="container-fluid">
                    Se va a cancelar la siguiente convocatoria:
                    <ul>
                        <li><strong>{row.nombreConvocatoria}</strong></li>
                        {row.nombreEmpleado && <li>Colaborador: {row.nombreEmpleado}</li>}
                    </ul>
                    La asignación de la vacante se eliminará y la convocatoria quedará en estado
                    <strong> Cancelado</strong>. Esta acción no se puede deshacer.
                    <br />
                    ¿Está seguro de esta acción?
                </div>
            </div>
            <div className="modal-footer justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary generic-button-ficha-outlined"
                    disabled={isSubmitting}
                    onClick={() => toggleModal()}>
                    Volver
                </button>
                <button
                    type="button"
                    className="btn btn-primary generic-button-ficha mr-2"
                    disabled={isSubmitting}
                    onClick={handleSubmit}>
                    Cancelar convocatoria
                </button>
            </div>
        </GenericModal>
    )
}

export default CancelarConvocatoriaModal
